import { useEffect, useState } from "react";
import api from "../../actions/api";
import { getErrorCode } from "../../reducers/Helper";
import { transformErrors } from "../../helpers/input";

export const useFetch = (url, disabled = false, axiosProps = {}) => {
    const { method = "get", params: paramsData = {}, responseType = "json", headers } = axiosProps;
    const [params, setParams] = useState({
        fetching: false,
        data: false,
        errors: false,
        serverError: false,
        status: false,
        loaded: false
    });

    useEffect(() => {
        const abortController = new AbortController();

        const fetchData = async () => {
            setParams(prevState => {
                return {
                    ...prevState,
                    loaded: false,
                    errors: false,
                    fetching: true,
                    status: false,
                    serverError: false
                }
            })
            api({
                method,
                responseType,
                url,
                data: (method !== "get" ? paramsData : {}),
                params: {
                    ...(method === "get" ? paramsData : {})
                },
                signal: abortController.signal,
                headers,
            })
                .then(response => {
                    setParams(prevState => {
                        return {
                            ...prevState,
                            fetching: false,
                            loaded: true,
                            status: response.status,
                            data: response.data
                        }
                    })
                })
                .catch(error => {
                    setParams(prevState => {
                        return {
                            ...prevState,
                            fetching: error.message === 'canceled' ? true : false,
                            errors: error.message,
                            status: getErrorCode(error),
                            serverError: transformErrors(error),
                            loaded: true
                        }
                    })
                })
        }

        if (disabled === false && url) {
            fetchData();
        }

        return () => {
            setParams(prevState => {
                return {
                    ...prevState,
                    fetching: false,
                }
            })
            abortController.abort();
        };
        // eslint-disable-next-line
    }, [url, disabled]);

    return params;
}